import { Directive, effect, inject, Injector, input, runInInjectionContext } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, EMPTY, map } from 'rxjs';

import { ChrAvatarDirective } from '@ciphr-design-system/angular';

import { HTTP_API_CLIENT, httpApiClientFactory } from '@ciphr/utils/data-adapters';

import { AVATARS_API_URL } from './avatars-api-url.token';

@Directive({
  selector: '[ciphrAvatar]',
  standalone: true,
})
export class AvatarDirective {
  private readonly avatarComponent = inject(ChrAvatarDirective, { self: true });
  private readonly avatarsApiUrl = inject(AVATARS_API_URL, { optional: true });
  private readonly httpApiClient = inject(HTTP_API_CLIENT);
  private readonly injector = inject(Injector);

  avatarPath = input<string | null | undefined>(undefined, { alias: 'ciphrAvatar' });

  constructor() {
    if (!this.avatarComponent) {
      throw "AvatarDirective must be used only on DS's chr-avatar component";
    }

    effect(() => {
      const avatar = this.avatarPath();
      if (avatar) {
        const url = (this.avatarsApiUrl || '/static/avatars/') + avatar;
        this.fetchAvatar(this.httpApiClient, url);
      } else if (avatar === null || avatar === undefined) {
        // Specified user has no avatar
        return;
      } else {
        // Logged in user's avatar
        const httpClient = runInInjectionContext(this.injector, httpApiClientFactory({ name: 'sso', version: 1 }));
        this.fetchAvatar(httpClient, '/static/avatars');
      }
    });
  }

  private fetchAvatar(httpClient: HttpClient, apiUrl: string): void {
    httpClient
      .get(apiUrl, { responseType: 'blob' })
      .pipe(
        map((res) => URL.createObjectURL(res)),
        catchError(() => EMPTY),
      )
      .subscribe((objectUrl) => (this.avatarComponent.image = objectUrl));
  }
}
